module.exports = __webpack_public_path__ + "img/29_18.1e302074.png";